import React, { Component } from "react";
import { Button, Pagination } from "zina-dogi-react";
import { HotTable } from "@handsontable/react";
import BarLoader from "react-spinners/BarLoader";
import CircleLoader from "react-spinners/CircleLoader";
import FilterSSOTItemModal from "./filter_ssot_item_modal";
import * as _ from "lodash";

export default class PartialCancellationTable extends Component {
    constructor() {
        super();
        this.hotTableComponent = React.createRef();
        this.state = {
            oet_ssoti: [],
            pagination: {
                actualPage: 1,
                previous: null,
                next: null,
                pages: 0,
                count: 0
            },
            ids: [],
            loading: false,
            select_all_ssot_items: false,
            loading_select_all: false
        };
        this.selectedRows = {
            ids: [],
            idm: [],
            length: 0
        };
    }

    componentWillMount() {
        if (this.state.oet_ssoti.length === 0 && this.state.pagination.pages === 0) {
            this.updateData(this.state.pagination.actualPage);
        }
    }

    updateData = (page = 1, site_ids = null, material_type = null) => {
        const { getData } = this.props;
        this.setState({ loading: true });

        getData(page, site_ids, material_type)
            .then(result => {
                if (result) {
                    this.setState({
                        oet_ssoti: result.list,
                        loading: false,
                        pagination: {
                            actualPage: result.pagination.actual,
                            pages: result.pagination.pages,
                            next: result.pagination.next,
                            previous: result.pagination.previous,
                            changePage: this.updateData,
                            count: result.pagination.count
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    };

    render() {
        console.log('noc')
        const { oet_ssoti, pagination } = this.state;
        const data = this.getData(oet_ssoti);
        const fathersIndex = data.filter(row => row.father).map(fatherRow => data.indexOf(fatherRow));
        const table_op = {
            width: "100%",
            height: 350,
            stretchH: "all",
            afterChange: this.onAfterChange,
            settings: {
                tableClassName: ["table", "table-bordered", "table-striped"],
                fillHandle: true,
                wordWrap: true,
                stretchH: "none",
                className: "htCenter htMiddle",
                colHeaders: getColHeaders(null, this.props.cancelled),
                columns: getColumns(null, this.props.cancelled),
                cells: (row, col) => {
                    let cellProperties = {};
                    if (fathersIndex.includes(row)) {
                        cellProperties.className = "rowFather htLeft htMiddle";
                    }
                    return cellProperties;
                },
                data
            }
        };
        return (
            <div>
                {this.props.run && this.props.oet && (
                    <div className={"m-2"}>
                        <FilterSSOTItemModal
                            ref="filter_ssot_item_modal"
                            run={this.props.run}
                            oet={this.props.oet}
                            updateData={this.updateData}
                            parentComponent={this}
                        />
                        <div className="row">
                            <div className="col-lg-12 control-ssot-items">
                                <Button color="primary" onClick={() => this.refs.filter_ssot_item_modal.toggle()}>
                                    Filter SSOT Items
                                </Button>
                                <a href="#s" onClick={this.onClickSelectAll} className="select-all-ssot-items">
                                    {this.state.select_all_ssot_items ? "Unselect all" : "Select all"}
                                </a>
                                <CircleLoader loading={this.state.loading_select_all} color={"#007bff"} />
                            </div>
                        </div>
                    </div>
                )}
                <div>
                    <HotTable ref={this.hotTableComponent} {...table_op} />
                    <div className="row">
                        <div className="col-md-4">
                            <br />
                            <span>Total {pagination.count}</span>
                        </div>
                        <div className="col-md-4">{pagination && <Pagination {...pagination} />}</div>
                        <div className="col-md-4"></div>
                    </div>
                    {this.state.loading && (
                        <div className="loading">
                            Loading ...
                            <BarLoader sizeUnit={"px"} size={200} color={"#fff"} loading={true} />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    getSelectedRows = () => this.selectedRows;
    resetSelectedRows = () =>
        (this.selectedRows = {
            rows: [],
            ids: [],
            length: 0
        });

    onClickSelectAll = () => {
        const select_all_ssot_items = !this.state.select_all_ssot_items;
        if (select_all_ssot_items) {
            this.setState({ select_all_ssot_items: select_all_ssot_items, loading_select_all: true });
            const ssot_items_ids_filter = this.state.oet_ssoti ? this.state.oet_ssoti.map(item => item.id) : [];
            const ssot_ids = _.uniq(_.concat(ssot_items_ids_filter, this.selectedRows.ids));
            this.props.onSearchSsotItems(ssot_ids, "all").then(result => {
                const ids = result.id__in__matches;
                this.setState({ ids, loading_select_all: false });
                this.selectedRows = { ...this.selectedRows, idm: ids, ids };
            });
        } else {
            this.resetSelectedRows();
            this.setState({ ids: [], select_all_ssot_items: select_all_ssot_items });
        }
    };

    onAfterChange = (changes, typeChange, ...args) => {
        if (typeChange === "edit") {
            if (changes.length === 1) {
                const { hotInstance } = this.hotTableComponent.current;
                const [row, type, , newValue] = changes[0];
                if (type === "cancelled") {
                    const rowData = hotInstance.getSourceDataAtRow(row);
                    const { id } = rowData;
                    const idsIndex = this.selectedRows.ids.indexOf(id);
                    if (newValue) {
                        if (idsIndex === -1) {
                            const ids = [...this.selectedRows.ids, id];
                            const idm = this.selectedRows.idm;
                            let selectedRows = { ids, idm, length: ids.length };
                            this.selectedRows = selectedRows;
                        }
                    } else {
                        if (idsIndex > -1) {
                            this.selectedRows.ids.splice(idsIndex, 1);
                            this.selectedRows.length = this.selectedRows.ids.length;
                        }
                    }
                    this.props.onSearchSsotItems(this.selectedRows.ids).then(result => {
                        const ids = result.id__in__matches;
                        this.setState({ ids });
                        this.selectedRows = { ...this.selectedRows, idm: ids };
                    });
                }
            }
        }
    };

    getData = oet_ssoti => {
        let res = [];
        if (oet_ssoti && oet_ssoti.length > 0) {
            oet_ssoti.map(item => {
                const index = this.state.ids.indexOf(item.id);
                if (index !== -1) {
                    item.cancelled = true;
                } else {
                    item.cancelled = false;
                }
                const omc = item.item_omc;
                if (omc) {
                    omc.omc_id = omc.id;
                    delete omc.id;
                }
                const father = {
                    ...item,
                    material_code: item.cost_package.code,
                    voa_case: item.voa_case ? item.voa_case.name : null,
                    description: item.cost_package.name,
                    sap_wbs_region_description: item.site ? item.site.sap_wbs_region_description : null,
                    customer_site_code: item.site ? item.site.customer_site_code : null,
                    ...(omc ? omc : {}),
                    synergy: item.synergy !== null ? (item.synergy ? "Synergy Partner" : "Non Synergy Partner") : null,
                    father: true
                };
                delete father.site_service_order_template_item;
                res.push(father);
                return [];
            });
        }
        res = res.length === 0 ? [{}] : res;

        return res;
    };
}

const getColHeaders = (status, cancelled) => {
    let res = [
        ...(cancelled ? [] : [""]),
        "Material item <br>number",
        "Item Description",
        "Quantity",
        "Site Id<br>Name ",
        "Customer request<br>delivery date",
        "Project Request<br>delivery date",
        "Subcontractor<br>Supplier Code",
        "Subcontractor<br>Supplier",
        "Synergy",
        "SAP WBS<br>Region Description",
        "SAP WBS Zone<br>Description",
        "Site WBS<br>element",
        "WP ID",
        "SOG",
        "VOA Case",
        "Row Line<br>Number in the QC",
        "Service task list",
        "PO Release<br>Instructios",
        "Additional comment",
        "ACV ID",
        "Additional<br/>Extra Works Category",
        "VOA number",
        "VOA line item number",
        "Dummy PO",
        "Invoice Plan",
        "SvO/PO Naming",
        "Remarks",
        "JD Code",
        "p20 sales_order",
        "Customer PO<br>line item number",
        "Customer PO<br>line quantity",
        "SAP service order",
        "SAP PR number",
        "SAP purchase order",
        "SVO maintenance<br>status"
    ];
    return res;
};

const getColumns = (status, cancelled) => {
    let res = [
        ...(cancelled
            ? []
            : [
                  {
                      type: "checkbox",
                      data: "cancelled",
                      editor: false
                  }
              ]),
        {
            data: "material_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "quantity",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_site_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "project_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_name",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "synergy",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_wbs_region_description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_wbs_zone_description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "site_wbs_element",
            className: "htRihtLeftght htMiddle",
            editor: false
        },
        {
            data: "wp_id",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sog",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_case",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "row_line_number_qc",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "service_task_list",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "po_related_instruction",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "additional_comment",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "acv_id",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "extra_works_category",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_item_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "dummy_purchase_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "invoice_plan",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "spo_vo_naming",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "remarks",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "jd_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "p20_sales_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_po_line_item_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_po_line_quantity",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_service_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_pr_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sap_purchase_order",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "svo_maintenance_status",
            className: "htLeft htMiddle",
            editor: false
        }
    ];
    return res;
};
